module.exports = {"441825100":"永和镇","441825104":"吉田镇","441825105":"太保镇","441825106":"禾洞镇","441825108":"福堂镇","441825109":"小三江镇","441825111":"上帅镇","441825450":"连山林场","441825451":"禾洞农林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441825.json
// module id = 2050
// module chunks = 0